import { ViewController } from 'elc-service';
import { computed, observable, action } from 'mobx';
import { SPEAK_SCREEN_LIMIT } from '../constants/Search';
import {
    SEARCH_TYPE_PARAM,
    VOICE_SEARCH_PARAM,
    SEARCH_PARAM
} from '../../internal/constants/Search';
import { events, emit } from 'elc-service-bus';
import { Config } from '../domain/entities/Config';

export class VoiceSearchViewController extends ViewController {
    @observable public isSpeakScreenOpen: boolean = false;
    @observable public allowPermission: boolean = false;
    @observable public voiceSearchFailure: boolean = false;
    @observable public showMicrophone: boolean = false;
    @observable public searching: boolean = false;
    @observable public configSearch: Config;

    public speakScreenLimit: number = SPEAK_SCREEN_LIMIT;
    private speakScreenhResetTimeout: number;
    private voiceSearchTerm: string = '';
    private searchUrl: string = '';

    constructor(config: Config) {
        super();
        this.configSearch = config;
        this.isLoading = false;
    }

    @computed
    get data() {
        return {
            isSpeakScreenOpen: this.isSpeakScreenOpen,
            voiceSearchTerm: this.voiceSearchTerm,
            voiceSearchFailure: this.voiceSearchFailure,
            allowPermission: this.allowPermission,
            searching: this.searching,
            config: this.configSearch.config
        };
    }

    @action
    public setSearchUrl(value: string) {
        this.searchUrl = value;
    }

    @action
    public closeSpeakScreen = () => {
        this.isSpeakScreenOpen = false;
    };

    @action
    public transcriptionCallback = (error: string, result: string) => {
        if (error || result === '') {
            this.voiceSearchFailure = true;
            this.searching = false;
            if (this.isSpeakScreenOpen) {
                this.hideSpeakScreen();
            }
        } else {
            this.searching = true;
            this.voiceSearchTerm = result;
            this.voiceSearchFailure = false;
            this.onSuccessResults();
        }
    };

    @action
    public onErrorCallback = () => {
        this.isSpeakScreenOpen = true;
        this.allowPermission = true;
        this.voiceSearchFailure = false;
        this.hideSpeakScreen();
    };

    @action
    public onSuccessCallback = () => {
        this.isSpeakScreenOpen = true;
        this.allowPermission = false;
        this.voiceSearchFailure = false;
    };

    @action
    public hideSpeakScreen = () => {
        clearTimeout(this.speakScreenhResetTimeout);
        this.speakScreenhResetTimeout = setTimeout(
            () => (this.isSpeakScreenOpen = false),
            this.speakScreenLimit
        );
    };

    @action
    public onSuccessResults = () => {
        const siteUrl = `${this.searchUrl}${SEARCH_PARAM}${this.voiceSearchTerm}${SEARCH_TYPE_PARAM}${VOICE_SEARCH_PARAM}`;
        emit(events.CHANGE_LOCATION, { redirectUrl: siteUrl });
    };
}
